import { Col, Divider, Row } from 'antd';
import { cloneDeep } from 'es-toolkit';

import Button from '../../../../../components/Buttons/Button';
import LADClaimsFilesCard from '../../Edit/Files/LADClaimsFilesCard';

const CreateLADFiles = ({ files, setFiles }) => {
  const setEditMode = (index, val) => {
    const filesLocal = cloneDeep(files);
    filesLocal[index].editMode = val;
    setFiles(filesLocal);
  };

  const handleAddNew = () => {
    const filesLocal = cloneDeep(files);

    const newBlock = {
      documentType: undefined,
      editMode: true,
      fileList: [],
      isNew: true,
    };

    filesLocal.push(newBlock);
    setFiles(filesLocal);
  };

  const handleCancel = (index, isNew) => {
    const filesLocal = cloneDeep(files);
    if (isNew) {
      filesLocal.splice(index, 1);
    } else {
      filesLocal[index].editMode = false;
    }
    setFiles(filesLocal);
  };

  const handleSubmit = (data, index) => {
    const filesLocal = cloneDeep(files);
    const currentBlock = filesLocal[index];

    const existingIndex = filesLocal.findIndex((b, i) => b.documentType === data.documentType && i !== index);

    if (existingIndex >= 0) {
      filesLocal[existingIndex].fileList.push(...data.fileList.map((f) => ({ ...f, dirtyFlag: 'I', editMode: false })));
      filesLocal.splice(index, 1);
    } else {
      filesLocal[index] = {
        ...currentBlock,
        ...data,
        dirtyFlag: 'I',
        editMode: false,
        fileList: data.fileList.map((f) => ({ ...f, dirtyFlag: 'I', editMode: false })),
        isNew: false,
      };
    }

    setFiles(filesLocal);
  };

  const handleDelete = (index) => {
    const filesLocal = cloneDeep(files);
    filesLocal.splice(index, 1);
    setFiles(filesLocal);
  };

  return (
    <div className="d-flex flex-direction-column h-100 overflow-hidden">
      <Row className="align-items-center px-15" justify="space-between">
        <Col />
        <Col>
          <Row justify="end" gutter={16}>
            <Col>
              <Button onClick={handleAddNew}>Add New Document</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100" />
      <div className="flex-1 custom-scroll-bar">
        <div className="px-15">
          {files.map((row, index) => (
            <LADClaimsFilesCard
              fileDetails={row}
              key={`${row.sequence}-${row.documentType}`}
              index={index}
              editMode={Boolean(row.editMode)}
              setEditMode={setEditMode}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreateLADFiles;
